<script setup>
import { ref, provide, computed, defineAsyncComponent } from 'vue'
import { usePage } from '@inertiajs/vue3'

import FlashMessage from '@/Components/Shared/FlashMessage.vue'
import Header from '@/Components/Company/Header/Header.vue'
import Sidebar from '@/Components/Company/Sidebar/Sidebar.vue'
import DefaultPageWrapper from '@/Components/Company/PageWrapper/DefaultPageWrapper.vue'
import CommandPalette from '@/Components/Shared/CommandPalette/CommandPalette.vue'
import PasswordExpirationBanner from '@/Components/Company/PageWrapper/PasswordExpirationBanner.vue'

const AiChatSlideover = defineAsyncComponent(
  () => import('@/Components/Company/AiChat/AiChatSlideover.vue')
)

const page = usePage()

const renderDesktopSidebar = computed(() => page.props.meta?.renderDesktopSidebar ?? true)

const renderDefaultPageWrapper = computed(() => page.props.meta?.renderDefaultPageWrapper ?? true)

const sidebarOpen = ref(false)
provide('sidebarOpen', sidebarOpen)

const toggleSidebarOpen = () => (sidebarOpen.value ^= true)
provide('toggleSidebarOpen', toggleSidebarOpen)

const aiChatOpen = ref(false)
const openAiChat = () => (aiChatOpen.value = true)
const closeAiChat = () => (aiChatOpen.value = false)
provide('openAiChat', openAiChat)
</script>

<template>
  <div class="flex flex-col h-screen">
    <PasswordExpirationBanner />
    <Header />
    <div class="z-10 flex flex-1 overflow-hidden">
      <Sidebar v-if="renderDesktopSidebar" />
      <main scroll-region class="flex-1 w-full overflow-y-scroll">
        <DefaultPageWrapper v-if="renderDefaultPageWrapper">
          <slot />
        </DefaultPageWrapper>
        <slot v-else />
      </main>
    </div>

    <FlashMessage class="mt-20" />
    <CommandPalette />
    <AiChatSlideover :isOpen="aiChatOpen" @open="openAiChat" @close="closeAiChat" />
  </div>
</template>
